import"./shared.js";import s from"./uid.js";import{s as e}from"../../../_virtual/shared.js";var o=e.exports,t=s,a=o("keys"),d=function(r){return a[r]||(a[r]=t(r))};export{d as default};
